import axios from "axios";

const API_URL = "/api/logs";

export const getMetricsData = async () => {
    try {
        const response = await axios.get("/api/logs/metrics", {
            withCredentials: true
        });

        console.log("📥 AXIOS RESPONSE :", response);
        console.log("📦 DATA :", response.data);

        return response;
    } catch (error) {
        console.error("❌ AXIOS ERROR :", error);
        throw error;
    }
};

export const getOverviewData = async () => {
    const res = await axios.get("/api/logs/overview", {
        withCredentials: true,
    });
    return res;
};

export const getUserLogs = async (userId: number) => {
    const res = await axios.get(`/api/logs/user/${userId}`, { withCredentials: true });
    return res;
};

export const getUserMetrics = async (userId: number) => {
    const res = await axios.get(`/api/logs/user/${userId}/metrics`, {
        withCredentials: true
    });
    return res;
};


export const getUserChapterLogs = async (userId: number, chapterName: string) => {
    const res = await axios.get(`/api/logs/user/${userId}/chapter/${encodeURIComponent(chapterName)}`, {
        withCredentials: true
    });
    return res;
};

//Creators : Florian Cohen-Joly  @3DDGAMES -- Under license